// @ts-nocheck
import React, { useEffect } from 'react'
import { CustomModal, GlobalStyle } from './styles'

import Menu from './menu'

import { useLocation } from 'react-router-dom'
import useBdApp from '../../hooks/bdapp/useBdApp'

interface MenuModalProps {
  isOpen: boolean
  onRequestClose: () => void
}

const MenuModal: React.FC<MenuModalProps> = ({ isOpen, onRequestClose }) => {
  const location = useLocation()
  const { isNative } = useBdApp()

  useEffect(() => {
    onRequestClose()
  }, [location]) // eslint-disable-line react-hooks/exhaustive-deps

  if (isNative) {
    return <Menu />
  }

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Menu Modal"
      style={{ overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' } }}
    >
      <Menu />

      <GlobalStyle />
    </CustomModal>
  )
}

export default MenuModal
